import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getModuleDataByModuleName } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import { ModuleType } from '../../../../../../../types/modules';
import { getSelectedTier } from '../../../../../../selectors/subscriptionsSection';
import { setSelectedTierEntityId } from '../../../../../../actions/subscriptionsSection';
import { getProfileGruser } from '../../../../../../selectors/users';
import { Props } from './TiersDropdown';

type StateProps = Pick<Props, 'tiers' | 'selectedTier'>;
type DispatchProps = Pick<Props, 'setSelectedTierEntityId'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => {
  const selectedTier = getSelectedTier(state);

  const gruser = getProfileGruser(state);
  const { tiers: tiersIds = [] } = getModuleDataByModuleName(state, gruser, ModuleType.TIERS);
  const tiers = getDeviationsByIds(state, tiersIds);
  return {
    tiers,
    selectedTier,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setSelectedTierEntityId,
};

export default connect(mapStateToProps, mapDispatchToProps);
